/**
 * 广场页
 * @returns
 */
import { Box, Flex, Image, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Masonry from "react-responsive-masonry";
import InfiniteScroll from "react-infinite-scroll-component";
import { Classic, Content, LikeOrCollect } from "@/types/content";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { ServerError } from "@/types/errors";
import {
  useGetClassicsQuery,
  useLazyGetContentsQuery,
  useLikeContentMutation,
  useCollectContentMutation,
  useGetContentsQuery,
} from "@/services/api/endpoints/content";
import ContentUnit from "@/components/content";
import Publish from "@/components/publish";
import WorkDetail from "@/components/workDetail";
import {
  selectMode,
  updateDesign,
  updateRefStructure,
  updateRefStyle,
} from "@/reducer/modeslice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { DesignParameter, LoraModel } from "@/types/design";
import { useNavigate } from "react-router-dom";
import { translate } from "@/utils/utils";
import { Tags } from "@/components/design/prompt";
import { NegTags } from "@/components/design/negtive_prompt";
import { BigModeImages } from "@/components/design/big_modal_images";
import { SmallModeImages } from "@/components/design/small_modal_images";
import ContentDetail from "@/components/contentdetail";
import Client4 from "@/services/api/client4";

const PER_PAGE_DEFAULT = 60;

const generateType: Record<string, string> = {
  decoration: "室内设计",
  architecture: "建筑设计",
  landscape: "景观设计",
  plane: "规划设计",
  general: "其他",
};

const Square = () => {
  const items = Array(100).fill(null);
  const detailControl = useDisclosure();
  const toast = useToast();
  const [allContents, setAllContents] = useState<Content[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [classic, setClassic] = useState<Classic[]>([]);
  const [currentClassIndex, setCurrentClassIndex] = useState(0);
  const [page, setPage] = useState(0);
  const [currentContentId, setCurrentContentId] = useState("");
  const [currentContent, setCurrentContent] = useState<Content>();

  const { data: classicList } = useGetClassicsQuery({});
  const user = useSelector(selectUser);
  const userId = user.id;

  const [getContents] = useLazyGetContentsQuery();

  const [likeContent] = useLikeContentMutation();
  const [collectContent] = useCollectContentMutation();

  const dispatch = useAppDispatch();
  const { design } = useAppSelector(selectMode);
  const navigate = useNavigate();

  const { addTags } = Tags();
  const { addTag } = NegTags();

  const classicName = classic[currentClassIndex]?.classic_name || "全部";
  const fetchData = async () => {
    // const classicName = classic[currentClassIndex]?.classic_name || "全部";
    const result = await getContents({
      page: page,
      per_page: PER_PAGE_DEFAULT,
      classicName: classicName,
      userId: userId,
      origin: 0,
    });
    const contents = result.data;
    console.log(contents);

    if (
      contents &&
      (contents.length === 0 || contents.length < PER_PAGE_DEFAULT)
    ) {
      setHasMore(false);
      if (page == 0) {
        setAllContents([...contents]);
      } else {
        setAllContents([...allContents, ...contents]);
      }
    } else if (contents) {
      if (page == 0) {
        setAllContents([...contents]);
      } else {
        setAllContents([...allContents, ...contents]);
      }
      setPage(page + 1);
    }
  };

  // 组件挂载后获取初始数据
  useEffect(() => {
    fetchData();
  }, [currentClassIndex]);

  const handChangeClassic = (index: number) => {
    if (index === currentClassIndex) {
      setAllContents([]);
      fetchData();
    } else {
      setAllContents([]);
      setCurrentClassIndex(index);
      setHasMore(true);
      setPage(0);
    }
  };

  useEffect(() => {
    if (classicList) {
      const all: Classic = { classic_name: "全部", id: "0", classic_order: 0 };
      const result = [all, ...classicList];
      setClassic(result);
    }
  }, [classicList]);

  // 刷新数据
  const refreshData = async () => {
    let refContents: Content[] = [];
    if (page === 0) {
      const result = await getContents({
        page: page,
        per_page: PER_PAGE_DEFAULT,
        classicName: classicName,
        userId: userId,
        origin: 0,
      });
      if (result.data) {
        refContents.push(...result.data);
        console.log(result.data,"21212");
        setAllContents([...refContents]);
      }
    } else if (page > 0) {
      const result = await getContents({
        page: 0,
        per_page: 60+(page-1)*PER_PAGE_DEFAULT,
        classicName: classicName,
        userId: userId,
        origin: 0,
      });
      if (result.data) {
        refContents.push(...result.data);
        console.log(refContents);
        setAllContents([...refContents]);
      }
    }
  };

  const handleClick = (content: Content) => {
    setCurrentContentId(content.id);
    setCurrentContent(content);
    detailControl.onOpen();
  };
  const handleOneClcik = (content: Content) => {
    // console.log(design)

    let newdesign = {
      ...design,
      mode: content.mode || "新手模式",
      generatetype: generateType[content.generate_type],
      width: content.width,
      height: content.height,
      seed: content.seed,
      steps: content.steps,
      cfgscale: content.cfgscale || 7,
      prompt: content.prompt,
      negativeprompt: content.negative_prompt,
      type: content.type,
      vaemodel: content.vae || "",
    } as DesignParameter;

    // 大模型反向匹配
    if (content.sd_model_checkpoint) {
      const bigmodel = BigModeImages.filter(
        (item) => item.realname === content.sd_model_checkpoint
      );
      newdesign.bigmodel = bigmodel[0];
    }
    // 小模型反向匹配
    if (content.lora) {
      const smallModes = content.lora;
      let smallmodel: LoraModel[] = [];
      const keys = Object.keys(smallModes);
      keys.map((keyitem) => {
        let Lora = SmallModeImages.filter(
          (item) => item.loraname === keyitem
        )[0];
        Lora.weight = smallModes[keyitem];
        smallmodel.push(Lora);
      });
      newdesign.smallmodel = smallmodel;
    }

    dispatch(updateDesign(newdesign));

    const refstructure = content.ref_structure
      ? [
          {
            url: content.ref_structure,
            weight: 1,
            refStructureType: content.ref_structure_type, //参照结构类型
            control_mode: content.control_mode || "My prompt is more important",
          },
        ]
      : [];
    dispatch(updateRefStructure(refstructure));

    const refstyle = content.ref_style
      ? [
          {
            url: content.ref_style,
            weight: 1,
          },
        ]
      : [];
    dispatch(updateRefStyle(refstyle));

    console.log(newdesign);

    if (content.prompt) {
      const tags = content.prompt.split(",");
      addTags(tags);
    }
    if (content.negative_prompt) {
      const tags = content.prompt.split(",");
      const negtags = content.negative_prompt.split(",");
      negtags.map((item) => addTag(item));
    }

    navigate("/ai/design"); // 切换到生图页
  };

  const updateUserInfo = async() => {
    const userInfo = await Client4.getMe();
    dispatch(updateUser(userInfo));
  };

  const handleOnLike = async (content: Content) => {
    console.log(">>>>>>>>>>123", page);
    const likeData: LikeOrCollect = {
      content_id: content.id,
      user_id: userId,
      status: !content.is_like,
    };

    const res = await likeContent(likeData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
    if(res){
      // setTimeout(()=>{
      //   refreshData();
      // }, 500)
      const newAllContents = allContents.map(item=>{
        if(item.id === content.id){
          return {
            ...item,
            is_like: !item.is_like,
            like_num: item.is_like? item.like_num-1 : item.like_num+1
          }
        }
        return item;
      })
      setAllContents([...newAllContents]);
      updateUserInfo();
    }
  };
  const handleOnCollect = async (content: Content) => {
    const collectData: LikeOrCollect = {
      content_id: content.id,
      user_id: userId,
      status: !content.is_collect,
    };

    const res = await collectContent(collectData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
      if(res){
        // setTimeout(()=>{  refreshData(); }, 500)
        const newAllContents = allContents.map(item=>{
          if(item.id === content.id){
            return {
              ...item,
              is_collect: !item.is_collect,
              collect_num:item.is_collect? item.collect_num-1 : item.collect_num+1
            }
          }
          return item;
        })
        setAllContents([...newAllContents]);
        updateUserInfo();
        
      }
  };

  return (
    <Box bgColor={"#000000"} h="calc(100vh - 61px)" overflow="hidden">
      <Box ml="30px" mr="30px" mb="40px">
        <Box
          mb="30px"
          h="54px"
          boxSizing="border-box"
          borderBottom={"2px solid #8E94A9"}
        >
          <Flex alignItems={"baseline"} gap={10}>
            {classic.map((item, index) => (
              <Box
                key={item.id}
                color={currentClassIndex === index ? "#FFFFFF" : "#CBD1DF"}
                fontSize={currentClassIndex === index ? "36px" : "18px"}
                cursor={"pointer"}
                onClick={() => handChangeClassic(index)}
              >
                {item.classic_name}
              </Box>
            ))}
          </Flex>
        </Box>
        <Box id="scrollableDiv" h="calc(100vh - 185px)" overflow="auto">
          <InfiniteScroll
            dataLength={allContents.length}
            scrollableTarget="scrollableDiv"
            next={fetchData}
            hasMore={hasMore}
            loader={<h4>Loading...</h4>}
          >
            <Masonry columnsCount={4}>
              {allContents.map((item, index) => (
                <Box p="3px" boxSizing="border-box" key={item.id}>
                  {/* 渲染每个项目的内容 */}
                  <ContentUnit
                    content={item}
                    onClick={() => handleClick(item)}
                    onOneClick={() => handleOneClcik(item)}
                    onLike={() => handleOnLike(item)}
                    onCollect={() => handleOnCollect(item)}
                  />
                </Box>
              ))}
            </Masonry>
          </InfiniteScroll>
        </Box>
      </Box>
      {/* <WorkDetail
        isOpen={detailControl.isOpen}
        onClose={detailControl.onClose}
        contentId={currentContentId}
      /> */}
      <ContentDetail
        isOpen={detailControl.isOpen}
        onClose={detailControl.onClose}
        contentId={currentContentId}
        onOneClick={() => handleOneClcik(currentContent!)}
      />
    </Box>
  );
};

export default Square;
